// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1IMc9","content":"Consent_content__36_rT","footer":"Consent_footer__3mZ4G"};